/* eslint-disable no-loop-func */
import 'moment/locale/id';
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import { getDetailAsync } from "../../reducers/monev/monev.actions";
import { RootState } from "../../store/rootReducer";

export const MonevReportPage = () => {
  moment.locale('id');

  const dispatch = useDispatch();
  const history = useHistory();

  const detailMonev = useSelector((state: RootState) => state.monev.selectedMonev);

  useEffect(() => {
    const paths = history.location.pathname.split("/");
    const idMonev = parseInt(paths[3]);
    if (!idMonev || isNaN(idMonev)) return;
    dispatch(getDetailAsync.request({ MONEV_ID: idMonev }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (detailMonev) {
      window.print();
    }
  }, [detailMonev])

  const renderPesertaDetail = () => {
    if (!detailMonev) return <div />;
    const pesertaDetail = detailMonev.PESERTA_DETAIL;
    if (!pesertaDetail) return <div />;
    let page = 0;
    const items: any = [];
    for (let counter = 0; counter < pesertaDetail.length; counter++) {
      if (!items[page]) items[page] = [];
      items[page].push(pesertaDetail[counter]);
      if (items[page].length === 20) {
        page++;
      }
    }
    const tables: JSX.Element[] = [];
    for (let tcounter = 0; tcounter < items.length; tcounter++) {
      tables.push(
        <React.Fragment>
          { tcounter > 0 ? <div className="pagebreak" /> : <div />}
          <div style={{ minHeight: `${tcounter === 0 ? '700px' : '900px'}` }}>
            { tcounter > 0 ? <div style={{ paddingTop: '150px' }} /> : <div /> }
            <table className="table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Nama Mahasiswa</th>
                  <th>NIM</th>
                </tr>
              </thead>
              <tbody>
                { items[tcounter].map((item: any, index: number) => (
                  <tr>
                    <td>{(tcounter * 20) + (index + 1)}</td>
                    <td>{item.NAMA_PESERTA}</td>
                    <td>{item.ID_PESERTA}</td>
                  </tr>
                )) }
              </tbody>
            </table>
          </div>
        </React.Fragment>
      );
    }
    return tables;
  }

  return (
    <MonevReportPageWrapper>
      <table className='page-wrapper'>
        <thead>
          <th>
            <div className='print-header'>
              <img className='print-header-logo' alt='UMN' src='/images/logo-umn-blue.svg' />
            </div>
          </th>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className='print-content'>
                <div className='content-head'>
                  <h1 className="title">Laporan Penyelenggara Kegiatan</h1>
                  <h2 className="monev-title">{ detailMonev?.NAMA_KEGIATAN }</h2>
                  <h3 className="university-name">Universitas Multimedia Nusantara</h3>
                  
                  <section className="partner-list">
                    { detailMonev?.DOK_DETAIL?.CO_DETAIL.map((item) => {
                      return <p>{item.CO_NAME}</p>
                    }) }
                  </section>
                  <hr/>
                </div>

                <table className="summary">
                  <tbody>
                    <tr>
                      <td>Nama Kegiatan</td>
                      <td>:</td>
                      <td></td>
                      <td>{ detailMonev?.NAMA_KEGIATAN }</td>
                    </tr>
                    {
                      detailMonev && detailMonev.PESERTA_KEGIATAN ? (
                        <tr>
                          <td>Peserta</td>
                          <td>:</td>
                          <td></td>
                          <td>
                            <p style={{ margin: 0 }} dangerouslySetInnerHTML={{ __html: detailMonev?.PESERTA_KEGIATAN ? detailMonev?.PESERTA_KEGIATAN : '' }} />
                          </td>
                        </tr>
                      ) : null
                    }
                    <tr>
                      <td>Tanggal Kegiatan</td>
                      <td>:</td>
                      <td></td>
                      <td>
                        {moment(detailMonev?.TANGGAL_MULAI_KEGIATAN).format('DD MMMM YYYY')}
                        —
                        {moment(detailMonev?.TANGGAL_SELESAI_KEGIATAN).format('DD MMMM YYYY')}</td>
                    </tr>
                    <tr>
                      <td>Lokasi</td>
                      <td>:</td>
                      <td></td>
                      <td>{ detailMonev?.LOKASI_KEGIATAN }</td>
                    </tr>
                    { detailMonev?.PENYELENGGARA_DETAIL.map((item, index) => {
                      if (index === 0) {
                        return (<tr>
                          <td>Penyelenggara</td>
                          <td>:</td>
                          <td></td>
                          <td>{item.NAME}</td>
                        </tr>);
                      } else {
                        return (<tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{item.NAME}</td>
                        </tr>);
                      }
                    }) }
                  </tbody>
                </table>

                <br/><br/>

                <h4>Detail Kegiatan</h4>
                <section className="detail-ev-kegiatan" dangerouslySetInnerHTML={{ __html: detailMonev?.DESCR_KEGIATAN ? detailMonev?.DESCR_KEGIATAN : '' }} />

                <br/><br/>

                <h4>Evaluasi Kegiatan</h4>
                <section className="detail-ev-kegiatan" dangerouslySetInnerHTML={{ __html: detailMonev?.DESCR_KEGIATAN ? detailMonev?.EVALUASI_KEGIATAN : '' }} />

                <br/><br/><br/>
                
                <div className={`signature ${ detailMonev && detailMonev.PESERTA_DETAIL.length > 0 ? '' : 'signature--long' }`}>
                  <table>
                    <tbody>
                      <tr>
                        <td>Tangerang, {moment(new Date()).format('DD MMMM YYYY')}</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Penyusun,</td>
                        <td>Mengetahui,</td>
                      </tr>
                      <tr>
                        <td>
                          <img alt='' className="signature--img" src="/images/signature-a.png" />
                        </td>
                        <td>
                          <img alt='' className="signature--img" src="/images/signature-b.png" />
                        </td>
                      </tr>
                      <tr>
                        <td><b><u>Siti Meisa Nurlaila</u></b></td>
                        <td><b><u>Boby Arinto</u></b></td>
                      </tr>
                      <tr>
                        <td>Relation & Cooperation Officer</td>
                        <td>Global Relations & Cooperation Manager</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                { detailMonev && detailMonev.PESERTA_DETAIL.length > 0 ? (
                  <React.Fragment>
                    <div className="pagebreak"></div>
                    <h4>Lampiran</h4>
                    <p>Daftar Peserta</p>
                    { renderPesertaDetail() }
                  </React.Fragment>
                ): null }
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <div className='print-footer'>
            Universitas Multimedia Nusantara, Jl. Scientia Boulevard, Gading Serpong, Tangerang, www.umn.ac.id
          </div>
        </tfoot>
      </table>
    </MonevReportPageWrapper>
  )
}

const MonevReportPageWrapper = styled.div`
  background: #fff;
  padding: 40px;

  .page-wrapper {
    & > thead > th,
    & > thead > th > td,
    & > tbody > tr,
    & > tbody > tr > td,
    & > tfoot > th,
    & > tfoot > th > td {
      border: none;
    }
    & > tbody {
      min-height: 100%;
    }
  }

  .table {
    border: 1px solid #000;

    & td, & th {
      border: 1px solid #000;
    }
  }

  table { page-break-inside:auto }
  tr { page-break-inside:avoid; page-break-after:auto }
  thead { display:table-header-group }
  tfoot { display:table-footer-group }

  h4 {
    font-weight: bold;
    letter-spacing: -1px;
    margin-bottom: 25px;
  }

  .print-content {
    .content-head {
      margin-bottom: 50px;

      .title, .monev-title, .university-name, .partner-list {
        margin: 0;
        text-align: center;
      }

      .title, .monev-title, .university-name {
        font-size: 24px;
        margin-bottom: 5px;
      }

      .partner-list {
        margin-top: 20px;

        & p {
          margin: 0;
        }
      }
    }

    .detail-ev-kegiatan {
      font-size: 14px;
    }

    .summary {
      & td {
        border: none;
        padding: 0;
        padding-bottom: 10px;

        &:nth-child(1) {
          padding-right: 50px;
        }

        &:nth-child(2) {
          padding-right: 10px;
        }
      }
    }

    .signature {

      &.signature--long {
        min-height: 800px;
      }

      table {
        width: 100%;
        border: none;
        margin-top: 50px;
        text-align: center;
        break-inside: avoid;
        margin-bottom: 50px;
        border-collapse: collapse;

        & td {
          border: none;
          padding: 0;
        }

        & .signature--img {
          height: 125px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }

  .print-header {
    height: 60px;
    position: relative;
    .print-header-logo {
      right: 0;
      top: 0px;
      width: 50px;
      position: absolute
    }
  }

  .print-footer {
    text-align: center;
  }

  @media print {
    padding: 0px;

    .pagebreak { page-break-before: always; }
  }
`;
